import React, { useState } from 'react';
import './Calculator.css';

// California county sales tax rates - 2024 data (sample values, would need to be updated with actual rates)
const countyRates = {
  'alameda': 10.25,
  'alpine': 7.25,
  'amador': 7.75,
  'butte': 7.25,
  'calaveras': 7.75,
  'colusa': 7.25,
  'contra costa': 8.75,
  'del norte': 8.5,
  'el dorado': 7.25,
  'fresno': 8.35,
  'glenn': 7.25,
  'humboldt': 8.5,
  'imperial': 7.75,
  'inyo': 7.75,
  'kern': 8.25,
  'kings': 7.25,
  'lake': 7.25,
  'lassen': 7.25,
  'los angeles': 10.25,
  'madera': 8.75,
  'marin': 8.75,
  'mariposa': 7.75,
  'mendocino': 7.875,
  'merced': 8.25,
  'modoc': 7.25,
  'mono': 7.25,
  'monterey': 9.25,
  'napa': 7.75,
  'nevada': 7.375,
  'orange': 7.75,
  'placer': 7.25,
  'plumas': 7.25,
  'riverside': 8.75,
  'sacramento': 8.75,
  'san benito': 9.0,
  'san bernardino': 8.75,
  'san diego': 8.75,
  'san francisco': 8.625,
  'san joaquin': 9.0,
  'san luis obispo': 7.75,
  'san mateo': 9.375,
  'santa barbara': 8.75,
  'santa clara': 9.375,
  'santa cruz': 9.75,
  'shasta': 7.25,
  'sierra': 7.25,
  'siskiyou': 7.5,
  'solano': 8.375,
  'sonoma': 9.0,
  'stanislaus': 8.25,
  'sutter': 7.25,
  'tehama': 7.25,
  'trinity': 7.25,
  'tulare': 7.75,
  'tuolumne': 7.25,
  'ventura': 7.75,
  'yolo': 8.25,
  'yuba': 7.25
};

function Calculator() {
  // State for selecting tax type
  const [taxType, setTaxType] = useState('sales');
  
  // States for sales tax calculator
  const [purchaseAmount, setPurchaseAmount] = useState('');
  const [county, setCounty] = useState('los angeles');
  const [isReverseCalculation, setIsReverseCalculation] = useState(false);
  const [salesTaxResult, setSalesTaxResult] = useState(null);
  
  // States for income tax calculator
  const [income, setIncome] = useState('');
  const [filingStatus, setFilingStatus] = useState('single');
  const [incomeTaxResult, setIncomeTaxResult] = useState(null);
  
  // States for property tax calculator
  const [propertyValue, setPropertyValue] = useState('');
  const [propertyCounty, setPropertyCounty] = useState('los angeles');
  const [propertyTaxResult, setPropertyTaxResult] = useState(null);
  
  // Income tax calculation
  const calculateIncomeTax = (e) => {
    e.preventDefault();
    
    const incomeValue = parseFloat(income);
    let tax = 0;
    
    if (filingStatus === 'single') {
      if (incomeValue <= 10099) {
        tax = incomeValue * 0.01;
      } else if (incomeValue <= 23942) {
        tax = 10099 * 0.01 + (incomeValue - 10099) * 0.02;
      } else if (incomeValue <= 37788) {
        tax = 10099 * 0.01 + (23942 - 10099) * 0.02 + (incomeValue - 23942) * 0.04;
      } else if (incomeValue <= 52455) {
        tax = 10099 * 0.01 + (23942 - 10099) * 0.02 + (37788 - 23942) * 0.04 + (incomeValue - 37788) * 0.06;
      } else if (incomeValue <= 66295) {
        tax = 10099 * 0.01 + (23942 - 10099) * 0.02 + (37788 - 23942) * 0.04 + (52455 - 37788) * 0.06 + (incomeValue - 52455) * 0.08;
      } else if (incomeValue <= 338639) {
        tax = 10099 * 0.01 + (23942 - 10099) * 0.02 + (37788 - 23942) * 0.04 + (52455 - 37788) * 0.06 + (66295 - 52455) * 0.08 + (incomeValue - 66295) * 0.093;
      } else if (incomeValue <= 406364) {
        tax = 10099 * 0.01 + (23942 - 10099) * 0.02 + (37788 - 23942) * 0.04 + (52455 - 37788) * 0.06 + (66295 - 52455) * 0.08 + (338639 - 66295) * 0.093 + (incomeValue - 338639) * 0.103;
      } else if (incomeValue <= 677275) {
        tax = 10099 * 0.01 + (23942 - 10099) * 0.02 + (37788 - 23942) * 0.04 + (52455 - 37788) * 0.06 + (66295 - 52455) * 0.08 + (338639 - 66295) * 0.093 + (406364 - 338639) * 0.103 + (incomeValue - 406364) * 0.113;
      } else {
        tax = 10099 * 0.01 + (23942 - 10099) * 0.02 + (37788 - 23942) * 0.04 + (52455 - 37788) * 0.06 + (66295 - 52455) * 0.08 + (338639 - 66295) * 0.093 + (406364 - 338639) * 0.103 + (677275 - 406364) * 0.113 + (incomeValue - 677275) * 0.123;
      }
    } else if (filingStatus === 'married') {
      // Simplified calculation for married filing jointly
      if (incomeValue <= 20198) {
        tax = incomeValue * 0.01;
      } else if (incomeValue <= 47884) {
        tax = 20198 * 0.01 + (incomeValue - 20198) * 0.02;
      } else if (incomeValue <= 75576) {
        tax = 20198 * 0.01 + (47884 - 20198) * 0.02 + (incomeValue - 47884) * 0.04;
      } else if (incomeValue <= 104910) {
        tax = 20198 * 0.01 + (47884 - 20198) * 0.02 + (75576 - 47884) * 0.04 + (incomeValue - 75576) * 0.06;
      } else if (incomeValue <= 132590) {
        tax = 20198 * 0.01 + (47884 - 20198) * 0.02 + (75576 - 47884) * 0.04 + (104910 - 75576) * 0.06 + (incomeValue - 104910) * 0.08;
      } else {
        tax = 20198 * 0.01 + (47884 - 20198) * 0.02 + (75576 - 47884) * 0.04 + (104910 - 75576) * 0.06 + (132590 - 104910) * 0.08 + (incomeValue - 132590) * 0.093;
      }
    } else if (filingStatus === 'head') {
      // Simplified calculation for head of household
      if (incomeValue <= 20212) {
        tax = incomeValue * 0.01;
      } else if (incomeValue <= 47887) {
        tax = 20212 * 0.01 + (incomeValue - 20212) * 0.02;
      } else if (incomeValue <= 61730) {
        tax = 20212 * 0.01 + (47887 - 20212) * 0.02 + (incomeValue - 47887) * 0.04;
      } else if (incomeValue <= 76397) {
        tax = 20212 * 0.01 + (47887 - 20212) * 0.02 + (61730 - 47887) * 0.04 + (incomeValue - 61730) * 0.06;
      } else if (incomeValue <= 90240) {
        tax = 20212 * 0.01 + (47887 - 20212) * 0.02 + (61730 - 47887) * 0.04 + (76397 - 61730) * 0.06 + (incomeValue - 76397) * 0.08;
      } else {
        tax = 20212 * 0.01 + (47887 - 20212) * 0.02 + (61730 - 47887) * 0.04 + (76397 - 61730) * 0.06 + (90240 - 76397) * 0.08 + (incomeValue - 90240) * 0.093;
      }
    }
    
    setIncomeTaxResult({
      income: incomeValue,
      tax: tax.toFixed(2),
      netIncome: (incomeValue - tax).toFixed(2)
    });
  };
  
  // Sales tax calculation
  const calculateSalesTax = (e) => {
    e.preventDefault();
    
    const amount = parseFloat(purchaseAmount);
    const taxRate = countyRates[county] || 7.25; // Default to base rate if county not found
    
    if (isReverseCalculation) {
      // Calculate pre-tax amount from total price
      const preTaxAmount = amount / (1 + (taxRate / 100));
      const taxAmount = amount - preTaxAmount;
      
      setSalesTaxResult({
        preTaxAmount: preTaxAmount.toFixed(2),
        taxAmount: taxAmount.toFixed(2),
        totalAmount: amount.toFixed(2),
        taxRate: taxRate
      });
    } else {
      // Calculate tax from pre-tax amount
      const taxAmount = amount * (taxRate / 100);
      const totalAmount = amount + taxAmount;
      
      setSalesTaxResult({
        preTaxAmount: amount.toFixed(2),
        taxAmount: taxAmount.toFixed(2),
        totalAmount: totalAmount.toFixed(2),
        taxRate: taxRate
      });
    }
  };
  
  // Property tax calculation
  const calculatePropertyTax = (e) => {
    e.preventDefault();
    
    const value = parseFloat(propertyValue);
    // California property tax is generally around 1% plus local assessments
    const baseRate = 0.01;
    // Add some variation by county (sample data)
    const countyMultiplier = {
      'los angeles': 1.16,
      'orange': 1.08,
      'san diego': 1.14,
      'san francisco': 1.18
    };
    
    const multiplier = countyMultiplier[propertyCounty] || 1.1;
    const effectiveRate = baseRate * multiplier;
    const annualTax = value * effectiveRate;
    
    setPropertyTaxResult({
      propertyValue: value.toFixed(2),
      annualTax: annualTax.toFixed(2),
      monthlyTax: (annualTax / 12).toFixed(2),
      effectiveRate: (effectiveRate * 100).toFixed(3)
    });
  };
  
  return (
    <div className="calculator-page">
      <h1>California Tax Calculator 2025</h1>
      
      <div className="tax-selector">
        <button 
          className={`tax-type-btn ${taxType === 'sales' ? 'active' : ''}`} 
          onClick={() => setTaxType('sales')}
        >
          Sales Tax
        </button>
        <button 
          className={`tax-type-btn ${taxType === 'income' ? 'active' : ''}`} 
          onClick={() => setTaxType('income')}
        >
          Income Tax
        </button>
        <button 
          className={`tax-type-btn ${taxType === 'property' ? 'active' : ''}`} 
          onClick={() => setTaxType('property')}
        >
          Property Tax
        </button>
      </div>
      
      <div className="calculator-container">
        {taxType === 'sales' && (
          <div className="tax-calculator">
            <h2>Sales Tax Calculator</h2>
            <form onSubmit={calculateSalesTax}>
              <div className="toggle-container">
                <label className="toggle">
                  <span className={!isReverseCalculation ? 'active' : ''}>Regular Calculation</span>
                  <div className="toggle-switch">
                    <input 
                      type="checkbox" 
                      checked={isReverseCalculation}
                      onChange={() => setIsReverseCalculation(!isReverseCalculation)}
                    />
                    <span className="slider"></span>
                  </div>
                  <span className={isReverseCalculation ? 'active' : ''}>Reverse Calculation</span>
                </label>
              </div>
              
              <div className="form-group">
                <label htmlFor="purchase-amount">
                  {isReverseCalculation ? 'Total Amount (including tax)' : 'Purchase Amount (before tax)'}
                </label>
                <div className="input-with-icon">
                  <span className="currency-symbol">$</span>
                  <input
                    type="number"
                    id="purchase-amount"
                    value={purchaseAmount}
                    onChange={(e) => setPurchaseAmount(e.target.value)}
                    min="0.01"
                    step="0.01"
                    required
                    placeholder="Enter amount"
                  />
                </div>
              </div>
              
              <div className="form-group">
                <label htmlFor="county">County</label>
                <select
                  id="county"
                  value={county}
                  onChange={(e) => setCounty(e.target.value)}
                >
                  {Object.keys(countyRates).sort().map(countyName => (
                    <option key={countyName} value={countyName}>
                      {countyName.charAt(0).toUpperCase() + countyName.slice(1)} ({countyRates[countyName]}%)
                    </option>
                  ))}
                </select>
              </div>
              
              <button type="submit" className="calculate-button">Calculate Sales Tax</button>
            </form>
            
            {salesTaxResult && (
              <div className="tax-results">
                <h3>Sales Tax Calculation Results</h3>
                <div className="result-item">
                  <span>Purchase Amount:</span>
                  <span>${parseFloat(salesTaxResult.preTaxAmount).toLocaleString()}</span>
                </div>
                <div className="result-item">
                  <span>Sales Tax Rate:</span>
                  <span>{salesTaxResult.taxRate}%</span>
                </div>
                <div className="result-item">
                  <span>Sales Tax Amount:</span>
                  <span>${parseFloat(salesTaxResult.taxAmount).toLocaleString()}</span>
                </div>
                <div className="result-item total">
                  <span>Total Price:</span>
                  <span>${parseFloat(salesTaxResult.totalAmount).toLocaleString()}</span>
                </div>
                <p className="disclaimer">
                  Calculation based on {salesTaxResult.taxRate}% sales tax rate for selected county.
                  Actual rates may vary by specific location within the county.
                </p>
              </div>
            )}
          </div>
        )}
        
        {taxType === 'income' && (
          <div className="tax-calculator">
            <h2>Income Tax Calculator</h2>
            <form onSubmit={calculateIncomeTax}>
              <div className="form-group">
                <label htmlFor="income">Annual Income</label>
                <div className="input-with-icon">
                  <span className="currency-symbol">$</span>
                  <input
                    type="number"
                    id="income"
                    value={income}
                    onChange={(e) => setIncome(e.target.value)}
                    min="0"
                    step="1000"
                    required
                    placeholder="Enter your annual income"
                  />
                </div>
              </div>
              
              <div className="form-group">
                <label htmlFor="filing-status">Filing Status</label>
                <select
                  id="filing-status"
                  value={filingStatus}
                  onChange={(e) => setFilingStatus(e.target.value)}
                >
                  <option value="single">Single</option>
                  <option value="married">Married Filing Jointly</option>
                  <option value="head">Head of Household</option>
                </select>
              </div>
              
              <button type="submit" className="calculate-button">Calculate Income Tax</button>
            </form>
            
            {incomeTaxResult && (
              <div className="tax-results">
                <h3>Income Tax Calculation Results</h3>
                <div className="result-item">
                  <span>Gross Income:</span>
                  <span>${parseFloat(incomeTaxResult.income).toLocaleString()}</span>
                </div>
                <div className="result-item">
                  <span>California State Income Tax:</span>
                  <span>${parseFloat(incomeTaxResult.tax).toLocaleString()}</span>
                </div>
                <div className="result-item total">
                  <span>Net Income After State Tax:</span>
                  <span>${parseFloat(incomeTaxResult.netIncome).toLocaleString()}</span>
                </div>
                <p className="disclaimer">
                  This is an estimate for California state income tax only. 
                  Federal taxes and other deductions are not included.
                </p>
              </div>
            )}
          </div>
        )}
        
        {taxType === 'property' && (
          <div className="tax-calculator">
            <h2>Property Tax Calculator</h2>
            <form onSubmit={calculatePropertyTax}>
              <div className="form-group">
                <label htmlFor="property-value">Property Assessed Value</label>
                <div className="input-with-icon">
                  <span className="currency-symbol">$</span>
                  <input
                    type="number"
                    id="property-value"
                    value={propertyValue}
                    onChange={(e) => setPropertyValue(e.target.value)}
                    min="0"
                    step="1000"
                    required
                    placeholder="Enter property assessed value"
                  />
                </div>
              </div>
              
              <div className="form-group">
                <label htmlFor="property-county">County</label>
                <select
                  id="property-county"
                  value={propertyCounty}
                  onChange={(e) => setPropertyCounty(e.target.value)}
                >
                  <option value="los angeles">Los Angeles</option>
                  <option value="orange">Orange</option>
                  <option value="san diego">San Diego</option>
                  <option value="san francisco">San Francisco</option>
                  <option value="other">Other Counties</option>
                </select>
              </div>
              
              <button type="submit" className="calculate-button">Calculate Property Tax</button>
            </form>
            
            {propertyTaxResult && (
              <div className="tax-results">
                <h3>Property Tax Calculation Results</h3>
                <div className="result-item">
                  <span>Property Value:</span>
                  <span>${parseFloat(propertyTaxResult.propertyValue).toLocaleString()}</span>
                </div>
                <div className="result-item">
                  <span>Effective Tax Rate:</span>
                  <span>{propertyTaxResult.effectiveRate}%</span>
                </div>
                <div className="result-item">
                  <span>Annual Property Tax:</span>
                  <span>${parseFloat(propertyTaxResult.annualTax).toLocaleString()}</span>
                </div>
                <div className="result-item total">
                  <span>Monthly Property Tax:</span>
                  <span>${parseFloat(propertyTaxResult.monthlyTax).toLocaleString()}</span>
                </div>
                <p className="disclaimer">
                  California property tax is generally 1% of the assessed value plus additional 
                  local assessments. Actual rates may vary.
                </p>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default Calculator;
